import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { ModusIconModule, ModusMenu, ModusMenuModule, ModusMenuTrigger } from '@trimble-gcs/modus';
import { filter } from 'rxjs';
import { CloseTreeMenu } from '../../scan-3d-panel/scan-3d.actions';
import { ScandataModel } from '../../scandata/scandata.models';
import { scandataTreeMenuTranslations } from './scandata-tree-menu.translations';

@UntilDestroy()
@Component({
  selector: 'sd-scandata-tree-menu',
  imports: [ModusIconModule, ModusMenuModule],
  templateUrl: './scandata-tree-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScandataTreeMenuComponent {
  private readonly actions$ = inject(Actions);

  readonly menu = viewChild.required<ModusMenu>(ModusMenu);
  readonly menuTrigger = viewChild.required<ModusMenuTrigger>(ModusMenuTrigger);

  readonly scan = input.required<ScandataModel>();
  readonly fitToViewDisabled = input<boolean>(false);
  readonly hasRotatePanoramasFeature = input<boolean>(false);
  readonly rotatePanoramasDisabled = input<boolean>(true);
  readonly stationHeadingOffsetDegrees = input<number>(0);
  readonly hasViewInNumarkFeature = input<boolean>(false);

  readonly modelDetailClick = output<ScandataModel>();
  readonly modelFitToViewClick = output<ScandataModel>();
  readonly modelRotatePanoramasClick = output<ScandataModel>();
  readonly viewInNumarkClick = output<ScandataModel>();

  readonly translations = scandataTreeMenuTranslations();

  readonly panoramaHeadingOffset = computed(() => {
    const offset = this.stationHeadingOffsetDegrees();
    return Math.round(offset) + '°';
  });

  constructor() {
    this.subscribeToCloseTreeMenu();
  }

  onModelDetailClick() {
    this.modelDetailClick.emit(this.scan());
  }

  onModelFitToViewClick() {
    this.modelFitToViewClick.emit(this.scan());
  }

  onRotatePanoramasClick() {
    this.modelRotatePanoramasClick.emit(this.scan());
  }

  onViewInNumarkClick() {
    this.viewInNumarkClick.emit(this.scan());
  }

  private subscribeToCloseTreeMenu() {
    this.actions$
      .pipe(
        ofActionDispatched(CloseTreeMenu),
        filter(() => this.menu().isOpen),
        untilDestroyed(this),
      )
      .subscribe(() => this.menuTrigger().closeMenu());
  }
}
